import React from 'react';
import ExpandableSection from './expandablesection';
import { useGlassData } from './windows/controls/glass/useGlassData';

const CloneConfigPanel = ({ cloneOverrides, setCloneOverrides }) => {
  const { getGlassEnergy, getGlassStrength, loading } = useGlassData();
  const glassEnergyOptions = getGlassEnergy();
  const glassStrengthOptions = getGlassStrength();

  return (
    <ExpandableSection
      title="Window Configuration"
      panelLocation="1"
    >
      <div style={{ padding: '16px', background: '#f8f9fa', borderRadius: 6 }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '16px'
        }}>

          {/* GLAZING TYPE */}
          <div>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>
              Glazing Type
            </label>
            <select
              value={cloneOverrides.glazingType1 || ''}
              onChange={(e) => {
                const value = e.target.value || null;
                setCloneOverrides(prev => ({ ...prev, glazingType1: value }));
                if (window.recalculateCurrentQuote) {
                  setTimeout(() => window.recalculateCurrentQuote(), 0);
                }
              }}
              style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
            >
              <option value="" disabled>Select one:</option>
              <option value="Double">Double</option>
              <option value="Triple">Triple</option>
            </select>
          </div>

          {/* GLASS ENERGY */}
          <div>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>
              Glass Energy
            </label>
            <select
              disabled={loading}
              value={cloneOverrides.glassEnergy1?.value || ''}
              onChange={(e) => {
                const selectedOpt = glassEnergyOptions.find(opt => opt.value === e.target.value);
                const newValue = selectedOpt ? { value: selectedOpt.value, label: selectedOpt.label } : null;
                setCloneOverrides(prev => ({ ...prev, glassEnergy1: newValue }));
                if (window.recalculateCurrentQuote) {
                  setTimeout(() => window.recalculateCurrentQuote(), 0);
                }
              }}
              style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
            >
              <option value="" disabled>Select one:</option>
              {glassEnergyOptions.map(opt => (
                <option key={opt.id} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>

          {/* GLASS STRENGTH */}
          <div>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>
              Glass Strength
            </label>
            <select
              disabled={loading}
              value={cloneOverrides.glassStrength1?.value || ''}
              onChange={(e) => {
                const selectedOpt = glassStrengthOptions.find(opt => opt.value === e.target.value);
                const newValue = selectedOpt ? { value: selectedOpt.value, label: selectedOpt.label } : null;
                setCloneOverrides(prev => ({ ...prev, glassStrength1: newValue }));
                if (window.recalculateCurrentQuote) {
                  setTimeout(() => window.recalculateCurrentQuote(), 0);
                }
              }}
              style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
            >
              <option value="" disabled>Select one:</option>
              {glassStrengthOptions.map(opt => (
                <option key={opt.id} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>

        </div>
      </div>
    </ExpandableSection>
  );
};

export default CloneConfigPanel;
